export default {"src":"/_next/static/media/progress-wide.mono.797500ed.svg","height":366,"width":591,"blurWidth":0,"blurHeight":0};